
export default {
  name: "ContentImage",

  props: {
    src: {
      type: String,
      required: true,
    },
  },

  methods: {
    getImg() {
      /* eslint-disable global-require,import/no-dynamic-require */
      if (!this.src) return null;
      return require(`~/assets/images/${this.src}`);
      /* eslint-enable */
    },
  },
};
